import React from 'react'
import {Flex} from '@components'
import {
    Form,
    Input,
    Checkbox,
    Row,
    Col,
    Button,
    Modal,
    Upload,
    Icon,
    message,
    Spin,
    InputNumber,
    Radio,
    DatePicker,
    Tooltip
} from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import {mkbz} from '@pages/Assembly/siderMenu/menuObj'
import {createUuid, getLoginUser} from '@utils/NHCore'
import NHFetch from '@utils/NHFetch'
import TitleTop from '@pages/Assembly/titleTop'
import NHSignDraw from '@components/common/NHSignDraw';
import NHFormItem from "@components/common/NHFormItem";
import CommonTip from '@pages/SelfHelp/common'
import NHModal from "@components/common/NHModal";
import Hint from '@pages/SelfHelp/common/hint'
import css from "./index.css";
import html2canvas from "html2canvas";
import NextButton from "@pages/SelfHelp/common/nextIndex";


// 定义一个默认图片路径
const defaultImagePath = require('./whitepicture.png');

const formItemLayout = {
    labelCol: {span: 6},
    wrapperCol: {span: 16}
}

@Form.create()
export default class Channel extends React.Component {
    state = {
        mkbz: 'GD005_20',
        hjmc: '',
        operable: true, //是否显示环节
        nonOperationalData: {}, //不可操作的数据
        loading: false,
        nextUrl: '',
        jxGjGg: {},
        XSSFTQD: '',
        XSCNQM: '',
        JZCNQM: '',
        JZSFQD: '',
        search: '',
        sqValue: '', //是否申请绿色通道
        data: {}, //绿色通道申请信息
        canOperateXs: false,//学生同意按钮操作状态
        canOperateJz: false,//家长同意按钮操作状态
        isCheckedXs: false, // 学生勾选按钮
        isCheckedJz: false, // 家长勾选按钮
        dkfsValue: '', //申请类型
        xsqzFlag: "0", //学生签字
        jzqzFlag: "0", //家长签字
        signatureXs: '', //学生签名对话框
        signatureJz: '', //家长签名对话框，
        xsblob: '', //学生的签名文件
        jzblob: '', //家长的签名文件
        edit: false
    }

    componentDidMount() {
        this.queryQztjAndYlhj()
        this.queryJxGjGg()
        console.log("getLoginUser(): ", getLoginUser());

    }

    queryJxGjGg = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : ''
        if (xsid === undefined) {
            message.error("没有登录！！！")
        } else {
            NHFetch('/zzbd/jxgg/queryJxGjGg', 'POST', {xsid: xsid})
                .then(res => {
                    if (res && res.code === 200) {
                        this.setState({
                            jxGjGg: res.data,

                        })
                    } else {
                        message.error("查询学生签订数据失败，请联系管理员")
                    }
                })
        }
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : ''
        if (!xsid) {
            this.setState({
                nonOperationalData: {nologin: true},
                operable: false
            })
            return
        }
        let zzbdhjid = this.getQueryString('pkid')
        NHFetch('/zzbd/queryQztjAndYlhj', 'GET', {xsid: xsid, zzbdhjid: zzbdhjid}).then(res => {
            if (res && res.data) {
                let kfsj = res.data['kfsj']
                let ylhj = res.data['ylhj']
                let qzhj = res.data['qzhj']
                let nohj = res.data['nohj']
                this.setState({nonOperationalData: res.data})
                if (kfsj && kfsj['YXSJ'] != '1') {
                    this.setState({operable: false})
                }

                if (ylhj && ylhj.length > 0) {
                    this.setState({operable: false})
                }

                if (qzhj && qzhj.length > 0) {
                    this.setState({operable: false})
                }
                if (nohj) {
                    this.setState({operable: false})
                }
            }
        })
    }


    getQueryString = name => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = menuList => {
        let nextCount = 0
        let bz = this.state.mkbz
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC
                this.setState({hjmc: hjmc})
                nextCount = index + 1
                return
            }
        })
        let menu = menuList[nextCount]
        if (menu) {
            let hjdm = menu.HJDM
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm]
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = '/customLink'
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: ''
            })
        }
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    handleSubmit = e => {
        e.preventDefault()

    }

    xsqzChange = (event) => {
        let re = event.target.value;
        this.setState({
            xsqz: re,
            signatureXs: '', //学生签名对话框
            canOperateXs: false,//学生同意按钮操作状态
            isCheckedXs: false, // 学生勾选按钮
            xsqzFlag: "0", //学生签字
        })

        this.handleXsModal()
    }

    jzqzChange = (event) => {
        let re = event.target.value;
        this.setState({
            jzqz: re,
            signatureJz: '', //家长签名对话框，
            canOperateJz: false,//家长同意按钮操作状态
            isCheckedJz: false, // 家长勾选按钮
            jzqzFlag: "0", //家长签字
        })

        this.handleJzModal()
    }

    /**请求是否已经签字 */
    handleXsModal = () => {
        this.refs.xsSiderRef.show();
        this.setState({canOperateXs: true})
    }

    /**请求是否已经签字 */
    handleJzModal = () => {
        this.refs.jzSiderRef.show();
        this.setState({canOperateJz: true})
    }

    handleClickCancelXs = () => {
        this.setState({
            xsqzFlag: '0'
        })
    }

    handleClickCancelJs = () => {
        this.setState({
            jsqzFlag: '0'
        })
    }



    // 修改后的 handleClickAggreeXs 方法
    handleClickAggreeXs = (stopLoading) => {
        let { canOperateXs, isCheckedXs, signatureXs, canOperateJz, isCheckedJz, signatureJz, jzblob } = this.state;

        if (!canOperateXs || !isCheckedXs) {
            message.info('学生请阅读完并勾选协议!', 1);
            stopLoading();
        } else if (signatureXs === '' || signatureXs == null) {
            message.info('学生请签名!', 1);
            stopLoading();
        } else {
            html2canvas(document.getElementById('signatureXs'), {
                allowTaint: true,
                useCORS: true,
                scale: 1
            }).then(canvas => {
                canvas.toBlob(blob => {
                    console.log("Xs blob :  " ,blob)

                    if (!canOperateJz || !isCheckedJz) {
                        message.info('家长请阅读完并勾选协议!', 1);
                        this.refs.xsSiderRef.close();
                        stopLoading();
                    } else if (signatureJz === '' || signatureJz == null) {
                        message.info('家长请签名!', 1);
                        this.refs.xsSiderRef.close();
                        stopLoading();
                    }
                    else {
                        console.log("signatureJz.toString() :" ,signatureJz.toString())
                        console.log("signatureXs.toString() :" ,signatureXs.toString())

                        let base64Stringjz = signatureJz.toString();
                        let cleanedStringjz = base64Stringjz.replace('data:image/png;base64,', '');

                        let base64Stringxs = signatureXs.toString();
                        let cleanedStringxs = base64Stringxs.replace('data:image/png;base64,', '');

                        let zzbdhjid = this.getQueryString('pkid')
                        let params = {};
                        params.jzblob = cleanedStringjz;
                        params.xsblob = cleanedStringxs;
                        params.xsxh = getLoginUser().userId;
                        params.zzbdhjid = zzbdhjid;
                        NHFetch('/zzbd/jxgg/signAnAgreementXs', 'POST', params).then(res => {
                            if (res && res.code === 200 && res.data > 0) {
                                message.info('保存成功!', 1);
                                this.refs.xsSiderRef.close();
                                this.queryQztjAndYlhj();
                                this.componentDidMount();
                            }
                        })
                    }
                })
            })
        }
    }

    // 修改后的 handleClickAggreeJs 方法
    handleClickAggreeJs = (stopLoading) => {
        let { canOperateJz, isCheckedJz, signatureJz, canOperateXs, isCheckedXs, signatureXs, xsblob } = this.state;

        if (!canOperateJz || !isCheckedJz) {
            message.info('家长请阅读完并勾选协议!', 1);
            stopLoading();
        } else if (signatureJz == '' || signatureJz == null) {
            message.info('家长请签名!', 1);
            stopLoading();
        } else {
            html2canvas(document.getElementById('signatureJz'), {
                allowTaint: true,
                useCORS: true,
                scale: 1
            }).then(canvas => {
                canvas.toBlob(blob => {
                    console.log("Jzblob :  " ,blob)

                    if (!canOperateXs || !isCheckedXs) {
                        message.info('学生请阅读完并勾选协议!', 1);
                        this.refs.jzSiderRef.close();
                        stopLoading();
                    } else if (signatureXs === '' || signatureXs == null) {
                        message.info('学生请签名!', 1);
                        this.refs.jzSiderRef.close();
                        stopLoading();
                    }
                    else {
                        console.log("signatureJz.toString() :" ,signatureJz.toString())
                        console.log("signatureXs.toString() :" ,signatureXs.toString())

                        const cleanBase64 = (str) => {
                            if (!str || typeof str !== 'string') return '';
                            // 移除头部信息但保留Base64有效内容
                            const base64 = str.replace(/^data:image\/\w+;base64,/, '').replace(/=+$/, '');
                            // 将 URL 不安全字符（+ 和 /）转换为 URL 安全字符（- 和 _）
                            return base64;
                        };

                        const cleanedStringjz = cleanBase64(signatureJz.toString());

                        const cleanedStringxs = cleanBase64(signatureXs.toString());

                        let zzbdhjid = this.getQueryString('pkid');
                        let params = {};
                        params.jzblob = cleanedStringjz;
                        params.xsblob = cleanedStringxs;
                        params.xsxh = getLoginUser().userId;
                        params.zzbdhjid = zzbdhjid;
                        NHFetch('/zzbd/jxgg/signAnAgreementXs', 'POST', params).then(res => {
                            if (res && res.code === 200 && res.data > 0) {
                                message.info('保存成功!', 1);
                                this.refs.jzSiderRef.close();
                                this.queryQztjAndYlhj();
                                this.componentDidMount();
                            }
                        })
                    }
                })
            })
        }
    }

    handleCheckboxXsChange = () => {
        let {isCheckedXs} = this.state;
        this.setState({isCheckedXs: !isCheckedXs});
    }

    handleCheckboxJzChange = () => {
        let {isCheckedJz} = this.state;
        this.setState({isCheckedJz: !isCheckedJz});
    }

    render() {
        const {form} = this.props
        const {
            jxGjGg,
            xsqzFlag,
            jzqzFlag,
            isCheckedXs,
            isCheckedJz,
            signatureXs,
            signatureJz,
            XSSFTQD,
            XSCNQM,
            JZCNQM,
            JZSFQD,
            canOperateXs,
            canOperateJz
        } = this.state;
        const date = new Date();


        return (
            <div style={{position: 'relative'}}>
                {this.state.operable ? (
                    <div>
                        <Flex className="w1180 mt-20" align="start">
                            <SiderMenu
                                ref={'siderMenu'}
                                setMenuList={this.setMenuList}
                                title="自助报到"
                                mkbz={this.state.mkbz}
                                /*     active={4}*/
                                menuType="自助报到"
                            />
                            <Flex.Item className="page_con_r" styleName="">
                                <Breadcrumb noLine list={[{name: '首页', url: '/index'}, {
                                    name: '自助报到',
                                    url: '/register'
                                }, {name: this.state.hjmc}]}/>
                                <div className="box">
                                    <Hint/>
                                    <TitleTop title={this.state.hjmc} extra={false}/>
                                    <br/>
                                    <br/>

                                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                        {
                                            (!jxGjGg || signatureXs) &&
                                            <>
                                            <div>学生签名:</div>
                                            <span style={{marginLeft: '10px'}}> {signatureXs ? (
                                                    <img src={signatureXs} style={{width: 200, height: 80}}/>)
                                                : (<img src={defaultImagePath}
                                                        style={{width: 200, height: 80}}/>)}</span>
                                            </>
                                        }
                                    </div>

                                        {
                                            !jxGjGg &&
                                            <p style={{textAlign: 'center'}}>
                                                <Button type="primary" form={form}
                                                        onClick={this.xsqzChange}>
                                                    学生签名
                                                </Button>
                                            </p>

                                        }
                                        <br/>
                                        <br/>
                                        <br/>
                                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                            {

                                                (!jxGjGg || signatureJz) &&
                                                <>
                                                <div>家长签名:</div>
                                                <span style={{marginLeft: '10px'}}> {signatureJz ? (
                                                        <img src={signatureJz} style={{width: 200, height: 80}}/>)
                                                    : (<img src={defaultImagePath}
                                                            style={{width: 200, height: 80}}/>)}</span>
                                                </>
                                            }
                                        </div>
                                        {
                                            !jxGjGg &&
                                            <p style={{textAlign: 'center'}}>
                                                <Button type="primary" form={form}
                                                        onClick={this.jzqzChange}>
                                                    家长签名
                                                </Button>
                                            </p>
                                        }
                                        {
                                            jxGjGg &&
                                            <p style={{fontSize: '24px', fontWeight: 'bold', textAlign: 'center'}}>
                                                你已经填过承诺书！
                                                <p/>
                                                <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                                            </p>

                                        }
                                        <br/>
                                        <br/>
                                        <br/>
                                        <div>
                                            <NHModal
                                                ref="xsSiderRef"
                                                width={800}
                                                okText="同意"
                                                cancelText="拒绝"
                                                title="家校共教共管"
                                                onOk={this.handleClickAggreeXs}
                                                onCancel={this.handleClickCancelXs}
                                            >
                                                <div style={{
                                                    marginLeft: '10px',
                                                    marginRight: '10px',
                                                    height: '100%',
                                                    width: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                }}>
                                                    <div id="signatureXs">

                                                        <br></br>
                                                        <br></br>
                                                        <span style={{marginLeft: '10px'}}> {signatureXs ? (
                                                                <img src={signatureXs} style={{width: 200, height: 80}}/>)
                                                            : (<img src={defaultImagePath}
                                                                    style={{width: 200, height: 80}}/>)}</span>
                                                        <div style={{
                                                            marginTop: '30px',
                                                            marginBottom: '30px',
                                                            marginLeft: '500px',
                                                            fontSize: '16px'
                                                        }}>
                                                            日期： {date.getFullYear()} 年 {date.getMonth() + 1} 月 {date.getDate()} 日
                                                        </div>
                                                    </div>
                                                    <NHSignDraw label={'学生签名'} style={{marginLeft: '10px'}}
                                                                onChange={value => this.setState({signatureXs: value?.signImg || ''})}/>


                                                    {
                                                        canOperateXs &&
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={isCheckedXs}
                                                                onChange={this.handleCheckboxXsChange}
                                                            />
                                                            &nbsp;<span
                                                            style={{
                                                                color: "red",
                                                                fontSize: "12px",
                                                                whiteSpace: 'normal'
                                                            }}>本人已认真阅读江苏农牧科技技术学院学院《家校共教共管促成长协议书》， 已全面知晓 并认可《家校共教共管促成长协议书》内容，愿意接受其所列内容的规范约束。如有违法违纪违规
              及违反上述承诺的行为， 自愿服从处理决定， 接受处理。</span>
                                                        </label>
                                                    }
                                                    <br/>
                                                    <br/>
                                                </div>


                                            </NHModal>
                                        </div>
                                        <div>
                                            <NHModal
                                                ref="jzSiderRef"
                                                width={800}
                                                okText="同意"
                                                cancelText="拒绝"
                                                title="家校共教共管"
                                                onOk={this.handleClickAggreeJs}
                                                onCancel={this.handleClickCancelJs}
                                            >
                                                <div style={{
                                                    marginLeft: '10px',
                                                    marginRight: '10px',
                                                    height: '100%',
                                                    width: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                }}>
                                                    <div id="signatureJz">

                                                        <br></br>
                                                        <br></br>
                                                        <span style={{marginLeft: '10px'}}> {signatureJz ? (
                                                                <img src={signatureJz} style={{width: 200, height: 80}}/>)
                                                            : (<img src={defaultImagePath}
                                                                    style={{width: 200, height: 80}}/>)}</span>
                                                        <div style={{
                                                            marginTop: '30px',
                                                            marginBottom: '30px',
                                                            marginLeft: '500px',
                                                            fontSize: '16px'
                                                        }}>
                                                            日期： {date.getFullYear()} 年 {date.getMonth() + 1} 月 {date.getDate()} 日
                                                        </div>
                                                    </div>
                                                    <NHSignDraw label={'家长签名'} style={{marginLeft: '10px'}}
                                                                onChange={value => this.setState({signatureJz: value?.signImg || ''})}/>


                                                    {
                                                        canOperateJz &&
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={isCheckedJz}
                                                                onChange={this.handleCheckboxJzChange}
                                                            />
                                                            &nbsp;<span
                                                            style={{
                                                                color: "red",
                                                                fontSize: "12px",
                                                                whiteSpace: 'normal'
                                                            }}>本人已认真阅读江苏农牧科技技术学院学院《家校共教共管促成长协议书》， 已全面知晓 并认可《家校共教共管促成长协议书》内容，愿意接受其所列内容的规范约束。如有违法违纪违规
              及违反上述承诺的行为， 自愿服从处理决定， 接受处理。</span>
                                                        </label>
                                                    }
                                                    <br/>
                                                    <br/>
                                                </div>


                                            </NHModal>
                                        </div>
                                    </div>
                            </Flex.Item>
                        </Flex>
                        <Spin style={{position: 'absolute', top: '300px', left: '60%'}}
                              spinning={this.state.loading}/>{' '}
                    </div>
                ) : (
                    <CommonTip hjmc={'家校共教共管'} key={'GD005_20'} mkbz="GD005_20"
                               nonOperationalData={this.state.nonOperationalData}/>
                )}
            </div>
        )
    }
}
